import { __decorate } from "tslib";
import { component } from 'tsdi';
let Config = class Config {
    get isProduction() {
        return window.location.hostname === 'pay.finion.com';
    }
    get isSandbox() {
        return window.location.hostname.includes('sandbox');
    }
    getBaseDomain(client) {
        switch (client) {
            case 'm':
                return 'magicline.com';
            case 'p':
                return 'perfectgym.com';
            case 'pl':
                return 'perfectleisure.com';
        }
    }
    get version() {
        return typeof VERSION !== 'undefined' ? VERSION : '1.0.0';
    }
    getApiEndpoint(tenant, client) {
        const domain = this.getBaseDomain(client);
        if (this.isProduction) {
            return `https://${tenant}.api.${domain}`;
        }
        if (this.isSandbox) {
            return `https://${tenant}.api.sandbox.${domain}`;
        }
        return `https://${tenant}.api.dev.${domain}`;
    }
    get paymentWidgetUrl() {
        if (this.isProduction) {
            return 'https://widget.payment.sportalliance.com/widget.js';
        }
        return 'https://widget.dev.payment.sportalliance.com/widget.js';
    }
    get paymentEnvironment() {
        if (this.isProduction) {
            return 'live';
        }
        if (this.isSandbox) {
            return 'sandbox';
        }
        return 'test';
    }
    getLocale() {
        return navigator.language.split('-')[0] ?? 'de';
    }
    get defaultCountryCode() {
        return 'DE';
    }
};
Config = __decorate([
    component()
], Config);
export { Config };
